<div class="ir-line th-header-search">
  <div class="ir-line--left">
    <div class="ir-btn th-btn-unactive">
      <i class="material-icons">search</i>
    </div>
  </div>

  <div class="ir-line--right">
    <div class="ir-btn th-btn-search" (click)="toggleClose.emit()">
      <i class="material-icons">close</i>
    </div>
  </div>
  <div class="ir-line--right">
    <div *ngIf="filtersApplied" class="ir-btn th-btn-search" (click)="resetFilters.emit()">
      <i class="material-icons">filter_alt_off</i>
    </div>
    <div class="ir-btn th-btn-search" (click)="openFilter.emit()">
      <i class="material-icons">tune</i>
    </div>
  </div>
  <div class="ir-line-content">
    <input
      autoFocus
      type="search"
      name="Search"
      placeholder="{{ 'common.placeholders.search' | translate }}"
      [(ngModel)]="filter.searchText"
      focus="showSearch"
    />
  </div>
</div>
